module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabs is-fullwidth"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.navActived.topten
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navClicked('topten')
      }
    }
  }, [_vm._v("今日十大")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.navActived.timeline
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navClicked('timeline')
      }
    }
  }, [_vm._v("发现")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.navActived.fav
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navClicked('fav')
      }
    }
  }, [_vm._v("版面")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.navActived.profile
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navClicked('profile')
      }
    }
  }, [_vm._v("我")])])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-333525de","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 239
// module chunks = 1